export default __webpack_public_path__ + "static/media/1.342ebd02.jpg";